import { SELECIONAR_ORIGEM } from '../types';

export default function selecionarOrigem (origem) {
  return {
    type: SELECIONAR_ORIGEM,
    payload: origem
  }
}
